export default {
  validation: {
    required: 'Ini adalah pertanyaan yang wajib diisi',
    kana_format: 'Ketik Katakana',
    email_format: '@.lower:validation.variables.email tidak benar',
    date_format: 'Ketik @.lower:validation.variables.date',
    number_format: 'Ketik @.lower:validation.variables.number',
    halfwidth_number_format: 'Masukkan hanya digit setengah lebar',
    alphanumeric_format: 'Ketik @.lower:validation.variables.alphanumeric ',
    postal_number_no_hyphen: 'Ketik @.lower:validation.variables.postal_number',
    postal_number_format: 'Ketik @:validation.variables.postal_number',
    login_email_required: '@:validation.required',
    login_email_format: '@:validation.email_format',
    login_password_required: '@:validation.required',
    // login_password_format: "",
    // min_length: "",
    // max_length: "",
    // greater_than_or_equal_number: "",
    // greater_than_number: "",
    // less_than_or_equal_number: "",
    // less_than_number: "",
    max_digit: 'Masukkan maksimal {digit} digit.',
    max_digit_with_item: 'Silakan masukkan {item} dalam {digit} digit',
    // number_only: "",
    // decimal_max_digit: "",
    no_blank_or_newline: 'Dilarang menjawab hanya dengan spasi dan/atau jeda baris.',
    // invalid_zero_number: "",
    variables: {
      id_or_email: 'ID/alamat email',
      email: 'Alamat email',
      password: 'Kata sandi',
      kana: '',
      date: 'Tanggal (misal, 31/01/2023)',
      number: 'Angka',
      alphanumeric: 'Alfabet dan angka',
      postal_number: 'Kode pos',
    },
  },
}
